import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorPartnerCandidate } from "~/models/VendorPartner";

const paths = {
	index: "/vendors/vendor_partner_candidates"
} as const;

type TIndex = (name: string) => SwrReturnType<VendorPartnerCandidate[]>;
type ReturnType = {
	index: TIndex;
};

export const useVendorPartnerCandidates = (): ReturnType => {
	const index: TIndex = (name: string) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isLoading } = useSWR<VendorPartnerCandidate[]>(
			{
				params: { name },
				url: paths.index
			}
		);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	return { index };
};
